import type { BoardData, PortableImportError } from '@stageplottter/core';
import { ApiError } from '../../../api/client';

/** What the boards page shows about a picked board file before uploading it (U7). */
export interface BoardFileSummary {
  name: string;
  items: number;
  channels: number;
  files: number;
}

export function summarizeBoardFile(data: BoardData, files: number): BoardFileSummary {
  return {
    name: data.meta.name,
    items: Object.keys(data.items).length,
    channels: Object.keys(data.channels).length,
    files,
  };
}

/** i18n key for a problem found while reading the file locally. */
export function localImportErrorKey(error: PortableImportError): string {
  return `boardImport.error.${error}`;
}

const SERVER_CODES: Record<string, string> = {
  payload_too_large: 'too-large',
  'limit.storage': 'storage',
  'limit.boards': 'boards',
  FST_ERR_CTP_INVALID_JSON_BODY: 'invalid-json',
};

/** i18n key for an import rejected by the server; null = use the generic API error message. */
export function serverImportErrorKey(err: unknown): string | null {
  if (!(err instanceof ApiError)) return null;
  if (err.code.startsWith('import.')) return `boardImport.error.${err.code.slice(7)}`;
  const known = SERVER_CODES[err.code];
  return known ? `boardImport.error.${known}` : null;
}

/** Upload progress in whole percent (0 when the total is unknown). */
export function percent(loaded: number, total: number): number {
  return total > 0 ? Math.min(100, Math.round((loaded / total) * 100)) : 0;
}
